/**
 * PublicAccountMismatchDialog — shown instead of PublicLoginDialog when a
 * share-link visitor tries to take an action while already signed in with an
 * account that isn't authorized for this campaign (ShortLinkResolverPage's
 * by-slug pre-flight check found no access). Opening the normal sign-in form
 * would be confusing — they ARE signed in — so this offers one action:
 * sign out, then land on /login so they can come back in as the right
 * account.
 */
import * as React from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';

export interface PublicAccountMismatchDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSwitchAccount: () => void;
}

export function PublicAccountMismatchDialog({
  open,
  onOpenChange,
  onSwitchAccount,
}: PublicAccountMismatchDialogProps): React.ReactElement {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="public-account-mismatch-dialog" className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle>This account doesn&apos;t have access</DialogTitle>
          <DialogDescription>
            You&apos;re signed in, but this account doesn&apos;t have access to this campaign. Switch
            to an account that does to continue.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button type="button" onClick={onSwitchAccount}>
            Switch account
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
